import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { SearchConditionBase } from '@/common/util/search'

import Button from '@/components/view/atoms/button/Button'
import SortButton from '@/components/view/atoms/button/SortButton'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import ButtonList from '@/components/view/layouts/button/ButtonList'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'
import FormRow from '@/components/view/layouts/form/FormRow'

interface Props<T> {
  name: string | null
  currentValue: string | number | boolean | null
  setCondition: Dispatch<SetStateAction<T>>
  label: string
  placeholder?: string
}

const DisclosureSortKeyword = <T extends SearchConditionBase>({
  setCondition,
  label,
  currentValue,
  name,
  placeholder
}: Props<T>) => {
  const [value, setValue] = useState<string>()
  const [showing, setShowing] = useState<boolean>(false)
  useEffect(() => {
    if (currentValue == null) {
      setValue('')
    } else {
      setValue(String(currentValue))
    }
  }, [currentValue])

  const applyCondition = () => {
    setCondition((condition) => ({
      ...condition,
      [name!]: value
    }))
    setShowing(false)
  }

  const closeAndClear = () => {
    setValue('')
    setShowing(false)
  }

  return (
    <DisclosureWrapper
      disclosureNode={
        <>
          <FormRow size={TextBoxSize.FULL} direction='vertical' gap={8}>
            <TextField
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              size={TextBoxSize.FULL}
            />
            <ButtonList justify='start'>
              <Button color={'secondary'} onClick={() => setShowing(false)}>
                キャンセル
              </Button>

              <Button onClick={applyCondition}>適用</Button>
            </ButtonList>
          </FormRow>
        </>
      }
      onClickOutSide={closeAndClear}
      off={!showing}
    >
      <SortButton
        onClick={() => setShowing((showing) => !showing)}
        quantity={currentValue ? 1 : undefined}
        selected={!!currentValue}
        onClickDelete={
          currentValue
            ? () => {
                setValue('')
                setCondition((condition) => ({
                  ...condition,
                  [name!]: undefined
                }))
              }
            : undefined
        }
      >
        {label}
      </SortButton>
    </DisclosureWrapper>
  )
}

export default DisclosureSortKeyword
